import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
const getCommonExcelDetails = () => {
  return {
    savedFromDate: localStorage.getItem("savedFromDate"),
    savedToDate: localStorage.getItem("savedToDate"),
    user: JSON.parse(localStorage.getItem("user")),
  };
};


export const generateExcelFile = async (data, filename, sheetName, transformData, sheetHeading, amounttype) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  const { savedFromDate, savedToDate, user } = getCommonExcelDetails();
  const Name = user?.data?.company_name || "N/A";
  const Address = user?.data?.address || "N/A";

  // Apply transformation if provided
  const transformedData = transformData ? transformData(data) : data;

  let totalAmount = 0, totalCGST = 0, totalSGST = 0, totalIGST = 0;

  // Calculate totals only if amounttype exists in any row
  if (transformedData.some((item) => amounttype in item)) {
    totalAmount = transformedData.reduce((sum, item) => sum + (parseFloat(item[amounttype]) || 0), 0);
    totalCGST = transformedData.reduce((sum, item) => sum + (parseFloat(item["CGST"]) || 0), 0);
    totalSGST = transformedData.reduce((sum, item) => sum + (parseFloat(item["SGST"]) || 0), 0);
    totalIGST = transformedData.reduce((sum, item) => sum + (parseFloat(item["IGST"]) || 0), 0);

    // Append the total row
    transformedData.push({
      "Invoice Number": "TOTAL",
      "Date": "",
      "Party":"",
      "State": "",
      "CGST": totalCGST,
      "SGST": totalSGST,
      "IGST": totalIGST,
      "Paid Amount":"",
      "Pending Amount":"",
      "Amount": totalAmount,
    });
  }

  const formatDate = (dateString) => {
    return dateString
      ? new Date(dateString).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "";
  };

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  // Define heading section
  const heading = [
    ["Company Name", `: ${Name}`],
    ["Address", `: ${Address}`],
    ["Date", `: ${formatDate(savedFromDate)} To ${formatDate(savedToDate)}`],
    [],
    [sheetHeading],
    [],
  ];

  heading.forEach((row, index) => {
    const excelRow = worksheet.addRow(row);
    if ([0, 1, 2, 4].includes(index)) {
      excelRow.font = { bold: true, size: 14 };
    }
  });

  // Define headers
  const headers = Object.keys(transformedData[0]);
  const headerRow = worksheet.addRow(headers);
  headerRow.font = { bold: true, size: 12 };

  // Add transformed data
  transformedData.forEach((row) => {
    const rowData = Object.values(row);
    const excelRow = worksheet.addRow(rowData);

    // Make the "TOTAL" row bold
    if (row["Invoice Number"] === "TOTAL") {
      excelRow.font = { bold: true, size: 12 };
    }
  });

  // Save file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, filename);
};





// all pages excel download

export const excelDownload = (data, filename) => {
  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      return {
        "Invoice Number": item["invoice_number"],
        ...userDetails,
        "Date": item["invoice_date"],
        "Party": item["party_name"],
        "State": item["billing_state"],
        "CGST": parseFloat(item["cgst"]) || 0,
        "SGST": parseFloat(item["sgst"]) || 0,
        "IGST": parseFloat(item["igst"]) || 0,
        "Paid Amount": parseFloat(item["paid_amount"]) || 0,
        "Pending Amount": parseFloat(item["balance_amount"]) || 0,
        "Amount": parseFloat(item["grand_total"]) || 0,
      };
    });
  };

  generateExcelFile(data, filename, "Invoice", transformData, "Sales Invoice","Amount");
};


export const excelPaymentInDownload = (data, filename) => {
  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["payment_date"]
        ? new Date(item["payment_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "";

      return {
        "Invoice Number": item["invoice_number"],
        ...userDetails,
        "Payment Mode": item["pay_mode"],
        "Transaction ID": item["transaction_id"],
        "Customer": item["party_name"],
        "Payment Date": formattedDate,
        "Amount": parseFloat(item["amount"]) || 0,
      };
    });
  };

  generateExcelFile(data, filename, "Invoice Payment", transformData, "Sale PaymentIn");
};


export const excelQuotationDownload = (data, filename) => {
  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["quotation_date"]
        ? new Date(item["quotation_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "";

      return {
        "Quotation Number": item["quotation_prefix"] + item["quotation_number"],
        "Date": formattedDate,
        ...userDetails,
        "Party": item["party_name"],
        "State": item["billing_state"],
        "Amount": parseFloat(item["grand_total"]) || 0,
      };
    });
  };

  generateExcelFile(data, filename, "Quotation", transformData, "Quotation Report");
};


export const excelPurchaseVoucherDownload = (data, filename) => {
  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["bill_date"]
        ? new Date(item["bill_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "";

      return {
        "Bill No": item["bill_no"],
        "Date": formattedDate,
        ...userDetails,
        "Party": item["party_name"],
        "Paid Amount": parseFloat(item["paid_amount"]) || 0,
        "Pending Amount": parseFloat(item["pending_amount"]) || 0,
        "Amount": parseFloat(item["total_amount"]) || 0,
      };
    });
  };

  generateExcelFile(data, filename, "PurchaseVoucher", transformData, "Purchase Voucher Report");
};



export const excelPODownload = (data, filename) => {
  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["po_date"]
        ? new Date(item["po_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "";

      return {
        "PO Number": item["po_number"],
        "Date": formattedDate,
        ...userDetails,
        "Party": item["party_name"],
        "State": item["billing_state"],
        "Amount": parseFloat(item["grand_total"]) || 0,
      };
    });
  };

  generateExcelFile(data, filename, "PO", transformData, "Purchase Order Report");
};


export const excelPaymentOutDownload = (data, filename) => {
  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["payment_date"]
        ? new Date(item["payment_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "";

      return {
        "Bill Number": item["bill_no"],
        "Payment Date": formattedDate,
        ...userDetails,
        "Payment Mode": item["pay_mode"],
        "Transaction ID": item["transaction_id"],
        "Customer": item["party_name"],
        "Amount": parseFloat(item["amount"]) || 0,
      };
    });
  };

  generateExcelFile(data, filename, "PaymentOut", transformData, "Payment Out Report");
};


export const excelLedgerDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      return {
        "Name": item["ledger"] || "N/A",
        "Group Name": item["group_name"] || "N/A",
        "Opening Balance": parseFloat(item["opening_balance"]) || 0,
        ...userDetails,
      };
    });
  };

  try {
    generateExcelFile(data, filename, "Ledger", transformData, "Ledger Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
  }
};





export const excelBankBookDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["ledger_date"]
        ? new Date(item["ledger_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "N/A";

      return {
        "Description": item["description"] || "N/A",
        "Date": formattedDate,
        "Dr": parseFloat(item["dr"]) || 0,
        "Cr": parseFloat(item["cr"]) || 0,
        "Closing Balance": parseFloat(item["balance"]) || 0,
        ...userDetails,
      };
    });
  };

  try {
    generateExcelFile(data, filename, "BankBook", transformData, "Bank Book Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};


export const excelCashBookDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  const transformData = (data) => {
    return data.map((item) => {
      const userDetails = item["User Details"]
        ?.split("<br>")
        ?.reduce((acc, detail) => {
          const [key, value] = detail.split(":");
          if (key && value) {
            acc[key.trim()] = value.trim();
          }
          return acc;
        }, {});

      // Format the date to "dd-mm-yyyy"
      const formattedDate = item["ledger_date"]
        ? new Date(item["ledger_date"]).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : "N/A";

      return {
        "Type": item["type"] || "N/A",
        "Date": formattedDate,
        "Description": item["description"] || "N/A",
        "Dr": parseFloat(item["dr"]) || 0,
        "Cr": parseFloat(item["cr"]) || 0,
        "Closing Balance": parseFloat(item["balance"]) || 0,
        ...userDetails,
      };
    });
  };

  try {
    generateExcelFile(data, filename, "CashBook", transformData, "Cash Book Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};


export const excelPayRecContDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["payment_date"]
          ? new Date(item["payment_date"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Type": item["type"] || "N/A",
          "Payment Date": formattedDate,
          "Payment Name": item["payment_name"] || "N/A",
          "Debit Amount": parseFloat(item["debit_amount"]) || 0,
          "Credit Amount": parseFloat(item["credit_amount"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "PayRecCont", transformData, "PayRecCont Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};


export const excelJournalDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["voucher_date"]
          ? new Date(item["voucher_date"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Id": item["id"] || "N/A",
          "Voucher Date": formattedDate,
          "Voucher Name": item["voucher_name"] || "N/A",
          "Debit Amount": parseFloat(item["debit_amount"]) || 0,
          "Credit Amount": parseFloat(item["credit_amount"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "Journal", transformData, "Journal Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};

export const excelShareApplicationsDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["date_of_receipt"]
          ? new Date(item["date_of_receipt"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Date of Receipt": formattedDate,
          "Application No": item["application_no"] || "N/A",
          "Name": item["name"] || "N/A",
          "No of Shares Applied": parseInt(item["no_applied_share"], 10) || 0,
        };
      });
    };

    generateExcelFile(
      data,
      filename,
      "Share Applications",
      transformData,
      "Share Applications Master Report"
    );
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};

export const excelMembersMasterDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["date_added"]
          ? new Date(item["date_added"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Name": item["member_name"] || "N/A",
          "Email": item["email"] || "N/A",
          "Folio No": item["folio_no"] || "N/A",
          "Date": formattedDate,
        };
      });
    };

    generateExcelFile(
      data,
      filename,
      "Members Master",
      transformData,
      "Members Master Report"
    );
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};



export const excelledgerEntriesDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["ledger_date"]
          ? new Date(item["ledger_date"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Type": item["type"] || "N/A",
          "Date": formattedDate,
          "Description": item["description"] || "N/A",
          "Dr": parseFloat(item["dr"]) || 0,
          "Cr": parseFloat(item["cr"]) || 0,
          "Closing Balance": parseFloat(item["balance"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "ledgerEntries", transformData, "Ledger Entries Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};


export const excelGSTR1Download = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["InvoiceDate"]
          ? new Date(item["InvoiceDate"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Invoice Number": item["InvoiceNo"] || "N/A",
          "Financial Year": item["FinancialYear"] || "N/A",
          "Date": formattedDate,
          "Party GSTIN": item["PartyGSTIN"] || "N/A",
          "Party": item["PartyName"] || "N/A",
          "Billing State": item["BillingState"] || "N/A",
          "Shipping State": item["ShippingState"] || "N/A",
          "Product": item["name"] || "N/A",
          "HSN": item["hsn"] || "N/A",
          "Invoice Value": parseFloat(item["InvoiceValue"]) || 0,
          "Taxable Value": parseFloat(item["TaxableValue"]) || 0,
          "Tax Rate": parseFloat(item["TaxRate"]) || 0,
          "CGST Amount": parseFloat(item["CGSTAmount"]) || 0,
          "SGST Amount": parseFloat(item["SGSTAmount"]) || 0,
          "IGST Amount": parseFloat(item["IGSTAmount"]) || 0,
          "Total Tax Amount": parseFloat(item["TotalTaxAmount"]) || 0,
          "Item Total": parseFloat(item["ItemTotal"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "GSTR1", transformData, "GSTR1 Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};

export const excelGSTR2Download = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["InvoiceDate"]
          ? new Date(item["InvoiceDate"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Invoice Number": item["InvoiceNo"] || "N/A",
          "Financial Year": item["FinancialYear"] || "N/A",
          "Date": formattedDate,
          "Party GSTIN": item["PartyGSTIN"] || "N/A",
          "Party": item["PartyName"] || "N/A",
          "Billing State": item["BillingState"] || "N/A",
          "Shipping State": item["ShippingState"] || "N/A",
          "Product": item["name"] || "N/A",
          "HSN": item["hsn"] || "N/A",
          "Invoice Value": parseFloat(item["InvoiceValue"]) || 0,
          "Taxable Value": parseFloat(item["TaxableValue"]) || 0,
          "Tax Rate": parseFloat(item["TaxRate"]) || 0,
          "CGST Amount": parseFloat(item["CGSTAmount"]) || 0,
          "SGST Amount": parseFloat(item["SGSTAmount"]) || 0,
          "IGST Amount": parseFloat(item["IGSTAmount"]) || 0,
          "Total Tax Amount": parseFloat(item["TotalTaxAmount"]) || 0,
          "Item Total": parseFloat(item["ItemTotal"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "GSTR2", transformData, "GSTR2 Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};


export const DebtorsAgeingDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["invoice_date"]
          ? new Date(item["invoice_date"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Invoice #": (item["invoice_prefix"] ? item["invoice_prefix"] : "") + (item["invoice_number"] || ""),
          "Date": formattedDate,
          "Party": item["party_name"] || "N/A",
          "Pending Amount": parseFloat(item["pending_amount"]) || 0,
          "Invoice Amount": parseFloat(item["grand_total"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "DebtorsAgeing", transformData, "DebtorsAgeing Report","Invoice Amount");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};

export const CreditorAgeingDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["bill_date"]
          ? new Date(item["bill_date"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Bill #": item["bill_no"]|| "N/A",
          "Date": formattedDate,
          "Party": item["party_name"] || "N/A",
          "Pending Amount": parseFloat(item["pending_amount"]) || 0,
          "Invoice Amount": parseFloat(item["total_amount"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "DebtorsAgeing", transformData, "DebtorsAgeing Report","Invoice Amount");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};

export const GroupLedgers = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        return {
          "Ledger Name": item["ledger_name"]|| "N/A",
          "	Group Name": item["group_name"] || "N/A",
          "Opening Balance": parseFloat(item["opening_balance"]) || 0,
          "Closing Balance": parseFloat(item["closing_balance"]?.replace(/,/g, "")) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "GroupLedgers", transformData, "Group Ledgers Report","Closing Balance");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};

export const Farmers = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["date_added"]
          ? new Date(item["date_added"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "N/A";

        return {
          "Name": item["name"] || "N/A",
          "Address": item["address"] || "N/A",
          "Email": item["email"] || "N/A",
          "Phone": item["phone"] || "N/A",
          "PAN": item["pan"] || "N/A",
          "UAID": item["uaid"] || "N/A",
          "Father Name": item["father_name"] || "N/A",
          "Land Record": item["land_record"] || "N/A",
          "Product": item["product"] || "N/A",
          "Authorized Person ID": item["authorized_person_id"] || "N/A",
          "Address Beneficial": item["address_beneficial"] || "N/A",
          "Folio": item["folio"] || "N/A",
          "Gender": item["gender"] || "N/A",
          "Category": item["category"] || "N/A",
          "Date of Birth": item["dob"] || "N/A",
          "Bank Name": item["bankname"] || "N/A",
          "Account No": item["accountno"] || "N/A",
          "IFSC": item["ifsc"] || "N/A",
          "Land Holding": item["land_holding"] || "N/A",
          "Khasra No": item["khasrano"] || "N/A",
          "Share Amount": item["share_amount"] || "N/A",
          "Profile Image": item["profile_image"] || "N/A",
          "PAN Card": item["pan_card"] || "N/A",
          "UAID Document": item["uaid_doc"] || "N/A",
          "Date Added": formattedDate,
        };
      });
    };

    generateExcelFile(data, filename, "Farmers", transformData, "Farmers Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};


export const StockSummaryDownload = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  try {
    const transformData = (data) => {
      return data.map((item) => {
        const userDetails = item["User Details"]
          ?.split("<br>")
          ?.reduce((acc, detail) => {
            const [key, value] = detail.split(":");
            if (key && value) {
              acc[key.trim()] = value.trim();
            }
            return acc;
          }, {});

        // Format the date to "dd-mm-yyyy"
        const formattedDate = item["bill_date"]
          ? new Date(item["bill_date"]).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "";

        return {
          "Item Name": item["item_name"]|| "N/A",
          "Opening Stock Quantity": item["opening_stock_qty"] || "N/A",
          "Opening Stock Value": parseFloat(item["opening_stock_value"]) || 0,
          "Purchased (QTY)": parseFloat(item["total_purchased"]) || 0,
          "Sold (QTY)": parseFloat(item["total_sold"]) || 0,
          "Current Stock": parseFloat(item["current_stock"]) || 0,
          "Avg Purchase Price": parseFloat(item["avg_purchase_price"]) || 0,
          "Current Stock Value": parseFloat(item["current_stock_value"]) || 0,
        };
      });
    };

    generateExcelFile(data, filename, "StockSummaryDownload", transformData, "StockSummary Report");
  } catch (error) {
    console.error("Error generating Excel file:", error);
    alert("Failed to download the Excel file. Please try again.");
  }
};